import React from 'react';
import styled from 'styled-components';

type ContainerProps = {
  background: string;
  color: string;
  hoverColor?: string;
  small?: boolean;
};

const Container = styled.div<ContainerProps>`
  background: ${(props) => props.background};
  border-radius: 6px;
  display: inline-block;
  cursor: pointer;
  font-size: 15px;
  padding: ${(props) => (props.small ? '5px 19px' : '9px 32px')};
  color: ${(props) => props.color};
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    background: ${(props) => props.hoverColor};
  }
`;

type Props = {
  children: React.ReactNode;
  background?: string;
  color?: string;
  darkenOnHover?: boolean;
  onClick?: () => void;
  small?: boolean;
};
function FlatButton({
  children,
  background = 'transparent',
  color = 'black',
  darkenOnHover,
  onClick,
  small,
}: Props) {
  return (
    <Container
      background={background}
      color={color}
      hoverColor={darkenOnHover ? '#5464f514' : '#ffffff14'}
      onClick={onClick}
      small={small}
    >
      {children}
    </Container>
  );
}

export default FlatButton;
